// extracted by mini-css-extract-plugin
module.exports = {"module":"PayrollProfileList_module__3v0sx","content":"PayrollProfileList_content__WxfaY"};